import { render, staticRenderFns } from "./imLeave.vue?vue&type=template&id=f8626806"
import script from "./imLeave.vue?vue&type=script&lang=js"
export * from "./imLeave.vue?vue&type=script&lang=js"
import style0 from "./imLeave.vue?vue&type=style&index=0&id=f8626806&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports